/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  $('.cb-complementary-item input[type="radio"]').change(function () {
    let prdid = $(this).data('suggested_prdid');
    let priceval = $(this).data('cbprice');
    $(this).parents('.cb-complementary-itemid-' + prdid).find('.price-cb-complementary-itemid-' + prdid).html(priceval);
  });


  document.addEventListener('theme:cart:change', function (e) {
    let cbct = e.detail.cbct;
    let needAddRefEls = cbct.querySelectorAll('[data-cb_ref_dep_id]');
    
    for (let idx = 0; idx < needAddRefEls.length; idx++) {
      let mainEl = needAddRefEls[idx];
      let mainElQty =  mainEl.dataset.cb_qty;
      let mainElVarId =  mainEl.dataset.cb_varid;
      let mainElVarKey =  mainEl.dataset.item;
      let mainElRefVarId =  mainEl.dataset.cb_ref_dep_id;

      let refEl = cbct.querySelector('[data-cb_ref_dep_for="' + mainElVarKey + '"]');

      if (refEl === null) {
        // add
        let formDataVarRef = {
        'items': [{
          'id': mainElRefVarId,
          'quantity': mainElQty,
          'properties': {
            "__ref_dep_for": mainElVarKey
          }
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formDataVarRef)
        }).then((response) => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        });
      } else {
        let refElQty = refEl.dataset.cb_qty;
        if (refElQty !== mainElQty) {
          // change
          let formDataVarRef = {
            'id': mainElRefVarId,
            'quantity': mainElQty
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formDataVarRef)
          }).then((response) => {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          });
        }
      }
    }

    let needRemoveMainEls = cbct.querySelectorAll('[data-cb_ref_dep_for]');
    
    for (let idx = 0; idx < needRemoveMainEls.length; idx++) {
      let refEl = needRemoveMainEls[idx];
      let refElVarId =  refEl.dataset.cb_varid;
      let mainElVarKey =  refEl.dataset.cb_ref_dep_for;

      let mainEl = cbct.querySelector('[data-item="' + mainElVarKey + '"]');

      if (mainEl === null) {
        // remove ref dep
        let formDataVarRef = {
          'id': refElVarId,
          'quantity': 0
        };

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formDataVarRef)
        }).then((response) => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        });
      }
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
